<template>
    <ValidationProvider :name="label" :rules="rules" v-slot="{ errors, required }" :mode="validationmode" :vid="computedVid" slim>
        <div class="migrol-form__input-wrapper" :class="[cssclass, { 'migrol-form__input-wrapper--error' : errors.length > 0 }]" :style="computedStyle">
            <label :for="$id('input')" class="migrol-form__input-label" v-if="label">{{label}}{{(required ? '*' : '')}}</label>
            <div class="migrol-form__input-container">
                <div class="migrol-form__autocomplete">
                    <input class="migrol-form__input-field" :id="$id('input')" :placeholder="label" v-model="innerValue" v-on="inputListeners" type="text" :name="name" :autocomplete="autocomplete" :disabled="isDisabled" @keydown.down="onArrowDown" @keydown.up="onArrowUp" @keydown.enter="onEnter" @keypress="checkSapCharacters($event)">
                    <ul class="migrol-form__autocomplete-results" v-show="showResults">
                        <li v-for="(suggestion, i) in suggestions"
                            :key="i"
                            @click="setSuggestion(suggestion)"
                            class="migrol-form__autocomplete-result"
                            :class="{ 'migrol-form__autocomplete-result--active': i === arrowCounter }">
                            {{suggestion}}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="migrol-form__error-message">{{errors[0]}}</div>
        </div>
    </ValidationProvider>
</template>

<script>
    //import { isNullOrUndefined } from 'util';
    import $ from 'jQuery';
    import { ValidationProvider } from 'VeeValidate';
    import { allowCharacter } from '../utils/utilities'

    export default {
        inheritAttrs: false,
        props: {
            label: {
            },
            flex: {
                type: String,
                default: '1',
                required: false
            },
            value: {
                default: ''
            },
            rules: {
                type: [Object, String],
                default: null,
                required: false
            },
            validationmode: {
                type: [String, Function],
                required: false
            },
            vid: {
                type: String,
                default: ''
            },
            cssclass: {
                type: [Object, String],
                default: null,
                required: false
            },
            zipcode: {
                type: String,
                default: ''
            },
            city: {
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: null,
                required: false
            },
            autocomplete: {
                type: String,
                default: null,
                required: false
            },
            preventSAPSpecialChars: {
                type: Boolean,
                default: true,
                required: false
            }
        },
        data() {
            return {
                innerValue: '',
                suggestions: [],
                isOpen: false,
                arrowCounter: -1,
                inputDelayTimer: null
            }
        },
        computed: {
            computedStyle() {
                return this.flex != '1' ? { flex: this.flex } : null;
            },
            isDisabled() {
                return this.$attrs.disabled == true;
            },
            inputListeners() {
                var vm = this
                // `Object.assign` merges objects together to form a new object
                return Object.assign({},
                    // We add all the listeners from the parent
                    this.$listeners,
                    // Then we can add custom listeners or override the
                    // behavior of some listeners.
                    {
                        // This ensures that the component works with v-model
                        input: function (event) {
                            vm.onInput();
                            vm.$emit('input', event.target.value)
                        },
                        change: function (event) {
                            vm.$emit('change', event.target.value)
                        }
                    }
                )
            },
            computedVid() {
                if (this.vid !== '')
                    return this.vid;
                else
                    return this.$id('vid');
            },
            showResults() {
                return !this.isDisabled && this.isOpen && this.suggestions.length > 0;
            }
        },
        methods: {
            onInput() {
                if (this.isDisabled)
                    return;

                if (this.innerValue.length > 2) {
                    //wait a few ms before getting the results
                    if (this.time) {
                        clearTimeout(this.time);
                    }
                    this.time = setTimeout(() => {
                        this.isOpen = true;
                        this.getSuggestions();
                    }, 400);
                } else {
                    this.closeSuggestions();
                    this.suggestions = [];
                }
            },
            closeSuggestions() {
                this.isOpen = false;
                this.arrowCounter = -1;
            },
            getSuggestions() {
                var reqData = { street: this.innerValue, zipcode: this.zipcode, city: this.city };
                var vm = this;
                $.get('/migrolapi/' + window.CONFIG.language + '/places/StreetLookup', reqData)
                    .done((response) => {
                        vm.suggestions = response;
                    })
                    .fail(() => {
                        console.error('error getting autocomplete');
                    });
            },
            setSuggestion(suggestion) {
                this.innerValue = suggestion;
                this.$emit('input', this.innerValue)
                this.$emit('change', this.innerValue)
                this.closeSuggestions();
            },
            onArrowDown() {
                if (this.arrowCounter < this.suggestions.length - 1) {
                    this.arrowCounter = this.arrowCounter + 1;
                    this.scrollToCurrentSuggestion();
                }
            },
            onArrowUp() {
                if (this.arrowCounter > 0) {
                    this.arrowCounter = this.arrowCounter - 1;
                    this.scrollToCurrentSuggestion();
                }
            },
            onEnter() {
                this.setSuggestion(this.suggestions[this.arrowCounter]);
            },
            handleClickOutside(evt) {
                if (!this.$el.contains(evt.target)) {
                    this.closeSuggestions();
                }
            },
            scrollToCurrentSuggestion() {
                var elem = $(".migrol-form__autocomplete-results li:nth-child(" + (this.arrowCounter + 1) + ")");
                var containerHeight = elem.parent().height();
                var domElem = elem[0];
                var containerScrollTop = 0;
                if (domElem.offsetTop > containerHeight)
                    containerScrollTop = domElem.offsetTop - containerHeight;
                domElem.parentNode.scrollTop = containerScrollTop;
            },
            checkSapCharacters(evt) {
                if (this.preventSAPSpecialChars && !allowCharacter(evt.key)) {
                    evt.preventDefault();
                }                
            }
        },
        mounted() {
            document.addEventListener('click', this.handleClickOutside);
        },
        destroyed() {
            document.removeEventListener('click', this.handleClickOutside);
        },
        watch: {
            value: {
                immediate: true,
                handler(newVal) {
                    this.innerValue = newVal;
                }
            }
        },
        components: {
            ValidationProvider
        }
    }
</script>